import { render, staticRenderFns } from "./PageParametersView.vue?vue&type=template&id=316cc65d"
import script from "./PageParametersView.vue?vue&type=script&lang=js"
export * from "./PageParametersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports